import { BaseButton } from '../base-button/BaseButton';
import { ButtonProps } from './Button.types';
import { BUTTON_TEXT_POSITIONS } from './Button.types.constants';
import { TBaseButtonChildrenProps } from '../base-button/BaseButton.types';
import { forwardRef } from 'react';
import { ButtonTextChild } from '../base-button-children/button-text-child/ButtonTextChild';
import { View } from 'react-native';

const Button = forwardRef(
  (
    {
      textPosition = BUTTON_TEXT_POSITIONS.LEFT,
      text,
      textStyle,
      textDisabledStyle,
      textFocusStyle,
      textHoverStyle,
      textPressedStyle,
      textTestID: textTestIDProp,
      textEllipsizeMode,
      textNumberOfLines,
      children,
      subText,
      subTextStyle,
      accessibilityLabel: accessibilityLabelProp,
      ...buttonProps
    }: ButtonProps,
    ref,
  ) => {
    const { testID } = buttonProps;
    const textTestID = textTestIDProp ?? (testID ? `${testID}.text` : 'button.text');
    const accessibilityLabel =
      accessibilityLabelProp ?? (typeof text === 'string' ? text : typeof subText === 'string' ? subText : undefined);

    return (
      <BaseButton ref={ref} accessibilityLabel={accessibilityLabel} {...buttonProps}>
        {(baseButtonChildrenProps: TBaseButtonChildrenProps) => {
          const TextRender = (
            <ButtonTextChild
              {...{
                text,
                textStyle,
                textDisabledStyle,
                textFocusStyle,
                textHoverStyle,
                textPressedStyle,
                textTestID,
                textEllipsizeMode,
                textNumberOfLines,
                ...baseButtonChildrenProps,
              }}
            />
          );

          const MainRenderer = (
            <>
              {textPosition === BUTTON_TEXT_POSITIONS.LEFT && TextRender}
              {children && children(baseButtonChildrenProps)}
              {textPosition === BUTTON_TEXT_POSITIONS.RIGHT && TextRender}
            </>
          );

          return subText ? (
            <View style={{ flexDirection: 'column' }}>
              {MainRenderer}
              <ButtonTextChild
                {...{
                  text: subText,
                  textStyle: subTextStyle,
                  textDisabledStyle,
                  textFocusStyle,
                  textHoverStyle,
                  textPressedStyle,
                  textTestID,
                  textEllipsizeMode,
                  textNumberOfLines,
                  ...baseButtonChildrenProps,
                }}
              />
            </View>
          ) : (
            MainRenderer
          );
        }}
      </BaseButton>
    );
  },
);

export default Button;
